<template>
  <div class="header">
    <div @click="languageListShow()"
         class="header-lang">
      {{ getLanguageLabel }}
      <i class="el-icon-arrow-down"></i>
    </div>
    <div class="header-info">
      <img :src="userUrl" class="img">
      <span :title="scmAccount">{{ scmAccount }}</span>
      <span class="separator">|</span>
    </div>
    <div class="separator">|</div>
    <div class="header-types">
      <div @click="changePassword()" class="header-type">
        <span>{{$t('header.changePassword')}}</span>
      </div>
    </div>
    <div class="separator">|</div>
    <div class="header-types">
      <div @click="dropOut()" class="header-type">
        <i class="el-icon-third-shengchangongju"/>
        <span>{{$t('header.logout')}}</span>
      </div>
    </div>
    <div class="language_list"
         v-if="languageShow">
        <span v-for="item in languageList" :key="item.value" @click="setLanguage(item.value)">{{ item.label }}</span>
    </div>
  </div>
</template>

<script>
  const img = require('@/assets/imgAvatar.png');

  export default {
    name: 'Header',
    data() {
      return {
        languageShow: false,
        currentLanguage: 'zh',
        languageList: [{
          value: 'zh',
          label: '中文'
        }, {
          value: 'en',
          label: 'English'
        }],
        userUrl: '',
        userArr: JSON.parse(localStorage.getItem('user')),
        scmAccount: localStorage.getItem('scmAccount'),
        userSettingShow: false,
        isOpenMall: Boolean(localStorage.getItem('isOpenMall'))
      };
    },
    async created() {
      await this.gerAvatar();
    },
    mounted() {
      if (localStorage.getItem('lang')) {
        this.currentLanguage = localStorage.getItem('lang');
      } else {
        localStorage.setItem('lang', 'zh');
      }
      document.addEventListener('click', this.hideMenu);
    },
    computed: {
      getLanguageLabel() {
        const i = this.languageList.findIndex(item => item.value === this.currentLanguage);
        if (i === -1) {
          return '语言'
        }
        return this.languageList[i].label;
      }
    },
    methods: {
      hrefHost(type) {
        const urlObj = {
          0: '/userweb/index.html',
          1: '/productweb/#/product/list',
          2: '/saleweb/',
          3: '/entrustweb/',
          4: '/purchaseweb/',
          5: '/basecommonweb/',
          6: '',
          7: '/wechatweb/',
          8: '/helpweb/'
        };
        window.open(urlObj[type], '_blank');
      },
      async gerAvatar() {
        const Authorization = localStorage.getItem('token');
        const res = await this.qxAxios({
          method: 'get',
          url: '/user/avatar',
          headers: { Authorization },
          responseType: 'blob'
        });
        if (res.status === 200) {
          const blob = res.data;
          if (blob) {
            const reader = new FileReader();
            reader.readAsDataURL(blob);
            reader.onloadend = () => {
              this.userUrl = reader.result;
            };
          }
        } else {
          this.userUrl = img;
        }
      },
      overShow() {
        this.userSettingShow = true;
      },
      outHide() {
        this.userSettingShow = false;
      },
      dropOut() {
        localStorage.removeItem('token');
        window.location.href = '/scmweb/login';
      },
      changePassword() {
        this.$router.push('/change-password')
        // window.location.href = '/scmweb/change-password';
      },
      hideMenu(event) {
        // 检查点击目标是否是下拉框或触发元素
        if (!this.$el.contains(event.target)) {
          this.languageShow = false;
        }
      },
      languageListShow() {
        this.languageShow = !this.languageShow;
      },
      setLanguage(e) {
        if (localStorage.getItem('lang') !== e) {
          this.currentLanguage = e;
          localStorage.setItem('lang', e);
          this.$store.dispatch('switchLanguage', e)
        }
        this.languageShow = false;
      }
    }
  };
</script>

<style lang="scss">
  .header {
    width: 100%;
    height: 48px;
    color: #9fa9ba;
    background: white;

    & > div {
      float: right;
    }
  }

  .header-types {
    display: inline-block;
    height: 48px;
    overflow-x: auto;
  }

  .header-type {
    display: inline-block;
    margin-left: 15px;
    font-size: 16px;
    line-height: 48px;
    color: #9fa9ba;
    cursor: pointer;

    i {
      display: inline-block;
      margin: 0 4px;
    }

    &:hover {
      color: #8f9eb8;
    }
  }

  .header-info {
    position: relative;
    float: right;
    display: inline-block;
    max-width: 300px;
    height: 48px;
    // margin-right: 40px;
    text-align: left;
    // cursor: pointer;

    .img {
      width: 40px;
      height: 40px;
      margin: 3px 10px;
      border: 1px solid rgba(0, 0, 0, 0.2);
      border-radius: 50%;
    }

    span {
      display: inline-block;
      max-width: 120px;
      height: 48px;
      overflow: hidden;
      line-height: 48px;
      text-overflow: ellipsis;
      white-space: normal;
      color: #9fa9ba;

      .icon {
        height: 48px;
        font-size: 26px;
        line-height: 48px;

        &.icon-padding {
          padding: 0 5px 15px;
        }
      }

      .el-icon-setting {
        padding-left: 10px;
        font-size: 28px;
        line-height: 50px;
      }

      &:hover {
        color: #8f9eb8;
      }
    }
  }

  .userSetting {
    position: absolute;
    z-index: 9999;
    top: 40px;
    right: 40px;
    font-size: 12px;
    color: #9fa9ba;
    background: #fff;
    box-shadow: 0 0 3px rgba(86, 96, 117, 0.3);
    cursor: pointer;

    span {
      display: block;
      padding: 2px 15px;
      margin: 2px;

      &:hover {
        background: #f5f5f5;
      }
    }
  }

  .separator {
    float: right;
    display: inline-block;
    margin-left: 15px;
    font-size: 18px !important;
    line-height: 48px;
    color: #9fa9ba;
  }

  .header-lang {
    display: inline-block;
    margin-left: 15px;
    font-size: 16px;
    line-height: 48px;
    color: #9fa9ba;
    cursor: pointer;
    margin-right: 40px;
  }

  .language_list {
    background-color: #ffffff;
    position: absolute;
    right: 40px;
    top: 40px;
    font-size: 12px;
    box-shadow: 0 0 3px rgba(86, 96, 117, 0.3);
    cursor: pointer;
    z-index: 9999;
    span {
      display: block;
      margin: 2px;
      padding: 2px 15px;
      &:hover {
        background-color: #f5f5f5;
      }
    }
  }
</style>
